import styled, { keyframes } from "styled-components";

interface ISkeletonContent {
  width?: string | any;
  height?: string | any;
  marginTop?: string | any;
}

export const SkeletonCardWrapper = styled.div`
  border-radius: 0.75rem;
  display: flex;
  flex-direction: column;
  margin-top: 8px;
  // max-height: 60vh;
  position: relative;
  box-sizing: border-box;
  overflow-x: hidden;
  width: 400px;
  @media (max-width: 768px) {
    height: 65vh;
    width: 100%
  }
`;
export const SkeletonAnimation = keyframes`
100% {
      transform: translateX(100%);
    }
`;

export const SkeletonTitle = styled.div`
  width: 50%;
  border-radius: 5px;
  height: 20px;
  background-color: #dddbdd;
`;

export const SkeletonContent = styled.div<ISkeletonContent>`
  width: ${(props) => (props.width ? `${props.width}px` : `100%`)};
  height: ${(props) => (props.height ? `${props.height}px` : `100%`)};
  line-height: initial;
  margin-top: ${(props) => (props.marginTop ? `${props.marginTop}px` : `1rem`)};
  display: inline-block;
  height: 2.5rem;
  position: relative;
  overflow: hidden;
  border-radius: 5px;
  background: linear-gradient(90deg, #f9f8fe 0%, #efeff9 20%, #f9f8fe 100%);
`;

export const Circle = styled.div`
  padding: 2px;
  border-radius: 50%;
  border: 1px solid #a9a5be;
  width: 18px;
  height: 18px;
`;

export const SkeletonBoxAnimation = styled.div`
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  transform: translateX(-100%);
  background-image: linear-gradient(
    90deg,
    rgba(255, 255, 255, 0) 0,
    rgba(255, 255, 255, 0.2) 20%,
    rgba(255, 255, 255, 0.5) 60%,
    rgba(255, 255, 255, 0)
  );
  animation: ${SkeletonAnimation} 2s infinite;
`;

export const Seperator = styled.div`
  border-top: 1px dashed #e7e7f0;
  margin-top: 20px;
  margin-bottom: 16px;
`;
